// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialogContainer: {
    width: '600px',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  dialogTitle: {
    fontWeight: 'bold',
  },
  formList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    overflow: 'auto',
    maxHeight: '440px',
  },
  typeSelect: {
    width: '280px',
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  fieldLabel: {
    paddingTop: theme.spacing(1),
  },
  fieldSelect: {
    width: '200px',
  },
  fieldInputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  fieldInput: {
    width: '200px',
  },
  quantityText: {
    color: theme.palette.text.secondary,
  },
  hintText: {
    color: theme.palette.text.secondary,
    fontSize: '12px',
    marginTop: theme.spacing(0.5),
  },
  previewText: {
    fontWeight: 'bold',
  },
  notesInput: {
    width: '100%',
  },
  errorText: {
    color: theme.palette.error.main,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: '32px',
  },
  closeButton: {
    color: 'grey',
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-12px',
    marginLeft: '-12px',
  },
});

export default styles;
